import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-risk-profile-details',
  templateUrl: './risk-profile-details.component.html',
  styleUrls: ['./risk-profile-details.component.scss']
})
export class RiskProfileDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
